import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';
import css from './AboutPage.module.css';
import about1 from './UK27_about_image_1.jpg';
import about2 from './about2.png';
import about3 from './Web-Cover_2024.jpg';

const AboutPage = props => {
  const { location } = props;
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const isContactPage = location?.hash === '#contact';

  if (isContactPage) {
    return (
      <StaticPage
        title="Über Unterkunft-Kirchentag.de"
        description="Kontakt & Infos zu Unterkunft-Kirchentag.de – der kostenlosen Plattform der Churchpool GmbH, die Gastgeber:innen und Gäste für den Evangelischen Kirchentag 2027 in Düsseldorf verbindet."
        schema={{
          '@context': 'http://schema.org',
          '@type': 'AboutPage',
          description: 'About Kirchentag',
          name: 'About page',
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className={css.staticPageWrapper}>
            <center>
              <h1>Kontakt</h1>
            </center>
            <p>
              Wenn Du eine Unterkunft anbieten möchtest oder einen Sucheintrag erstellen möchtest,
              klicke bitte auf die Schaltfläche „
              <a href="/l/draft/00000000-0000-0000-0000-000000000000/new/features">
                +Neuen Eintrag erstellen
              </a>
              “ in der Ecke oben rechts auf der Webseite.
            </p>
            <p>
              Wenn Du mit dem/der Autor:in eines bestehenden Eintrags in Kontakt treten möchtest,
              kannst Du den/die Autor:in direkt kontaktieren, indem Du auf die „Kontaktieren“
              -Schaltfläche auf dem entsprechenden Nutzerprofil des/der Autor:in klickst.
            </p>
            <p>
              Wenn Du weitere Fragen, klicke <NamedLink name="HowItWorksPage">hier</NamedLink>, um zu unserem Häufig
              gestellte Fragen-Bereich zu gelangen. Wenn Du in unserem Häufig gestellte
              Fragen-Bereich keine Antwort auf deine Frage findest, kannst Du dich gerne an uns
              wenden, indem Du die folgende E-Mail-Adresse verwendest:{' '}
              <a href="mailto:kontakt@unterkunft-kirchentag.de">kontakt@unterkunft-kirchentag.de</a>
            </p>

            <p>
              Für Informationen und Kontaktstellen zu den Themen: Camping, Gemeinschaftsquartiere
              oder Hotels/Pensionen,{' '}
              <a href="https://www.kirchentag.de/unterkunft" target="_blank">
                {' '}
                klicke hier.
              </a>
            </p>
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </StaticPage>
    );
  }
  // prettier-ignore
  return (
    <StaticPage
      title="Über Unterkunft-Kirchentag.de"
      description="Über Unterkunft-Kirchentag.de – die kostenlose Plattform der Churchpool GmbH, die Gastgeber:innen und Gäste für den Evangelischen Kirchentag 2027 in Düsseldorf verbindet."
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Kirchentag',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.staticPageWrapper}>
          <center><h1>Über Unterkunft-Kirchentag.de</h1></center>
          <img src={about1} className={css.coverImage} />

          <p>
            Unterkunft-Kirchentag.de ist eine Internetplattform der <a href='https://www.churchpool.com/de/'>Churchpool GmbH</a> in enger Zusammenarbeit mit dem <a href='https://www.kirchentag.de'>40. Deutschen Evangelischen Kirchentag Düsseldorf 2027 e.V.</a>
          </p>
          <p>
            Der Kirchentag führt Menschen zusammen. Ein zentraler Bestandteil des Kirchentages ist seit jeher die Unterbringung von Besucher:innen in Privatunterkünften bei Einwohner:innen am Veranstaltungsort. So kommen Menschen miteinander ins Gespräch, lernen sich besser kennen und schließen neue Freundschaften.
          </p>
          <p>
            Unterkunft-Kirchentag.de verbindet unterkunftssuchende Personen mit unterkunftsanbietenden Personen für den Deutschen Evangelischen Kirchentag 2027 – kostenlos und in Echtzeit.
          </p>
          <p>
            Da kein Mittelsmann benötigt wird und Besucher:innen in Echtzeit mit Gastgeber:innen in Kontakt treten können, verbindet die Internetplattform Menschen unbürokratisch und schneller als auf herkömmlichem Weg.
          </p>
          <p>
            Wir ermutigen alle mitzumachen und Besucher:innen einen kostenlosen Schlafplatz, Stellplatz für Wohnmobile oder auch eine Zeltwiese zur Verfügung zu stellen.
          </p>
          <p>
            Wenn Du selbst keinen Unterkunft anbieten kannst, kannst Du die Webseite gerne in den sozialen Medien, mit Deinen Freunden und mit Deiner Familie teilen und bekannt machen.
          </p>
          <p>
            Wenn Du mehr darüber erfahren möchtest, wie genau die Webseite funktioniert und wie Du einen Eintrag erstellen kannst, <a href='/how-it-works'>klicke hier</a> und besuche den Bereich „Wie es funktioniert“.
          </p>

          <center><h1>Über Churchpool</h1></center>
          <img src={about2} className={css.coverImage} />

          <p>
            Churchpool ist eine ökumenische digitale Kommunikations- und Content-Plattform, die Gemeindemitglieder deutschlandweit datenschutzkonform mit ihren Kirchengemeinden und weiteren kirchlichen Einrichtungen verbindet.
          </p>
          <p>
            Auf Churchpool sind bereits über 2.000 Gemeinden aus verschiedensten Landeskirchen und Bistümern im Einsatz. Wir laden Euch und Eure Gemeinden sowie christlichen Vereine und Einrichtungen herzlich dazu ein, Euch auf Churchpool zu registrieren.
          </p>
          <p>
            Churchpool stellt darüber hinaus eine Fülle an Inhalten für Einzelpersonen bereit. Dazu zählen zum Beispiel christliche News, Events aus der Umgebung und vieles mehr.
          </p>
          <p>
            Weitere Informationen findest Du auf unserer Website: <a href='https://www.churchpool.com/de/'>www.churchpool.com</a>
          </p>
          <img src={about3} className={css.coverImage} />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
